import * as Api from "@api";
import * as C from "@components";
import clsx from "clsx";
import React from "react";
import css from "./video.card.module.scss";

export const enum VideoCardVariant
{
    W100Left,
    W40Bottom,
    W60Bottom,
    SmallAnimation
}

interface VideoCardVariantProps
{
    pageContent: Api.Content<typeof VideoCardVariant[number]>;
    variant: VideoCardVariant;
    textMaxWidth?: C.Width;
    className?: string;
    srcAnimation?: string;
    keyHeadline: string;
    keyBody: string;
}

export const VideoCard = ({ pageContent, textMaxWidth, variant, className, srcAnimation, keyHeadline, keyBody }: VideoCardVariantProps): React.FunctionComponentElement<VideoCardVariantProps> =>
{
    const classes = clsx(
        css["card"],
        {
            [css["card--w100-left"]]: variant === VideoCardVariant.W100Left,
            [css["card--w40-top"]]: variant === VideoCardVariant.W40Bottom,
            [css["card--w60-bottom"]]: variant === VideoCardVariant.W60Bottom,
            [css["card--small-animation"]]: variant === VideoCardVariant.SmallAnimation,
        },
        className
    );

    const ipadWidth = (variant === VideoCardVariant.W40Bottom || variant === VideoCardVariant.SmallAnimation)
        ? C.Width.W40P : variant === VideoCardVariant.W60Bottom ? C.Width.W60P : undefined;
    const textCentered = variant === VideoCardVariant.W40Bottom
        || variant === VideoCardVariant.W60Bottom
        || variant === VideoCardVariant.SmallAnimation;

    return (
        <C.Card className={classes} layout={{ all: { width: C.Width.W100P }, ipad: { width: ipadWidth } }} useWrapper>
            <C.PageContentBlock
                keys={[keyHeadline, keyBody]}
                pageContent={pageContent}
                className={css['cardContent']}
                items={{
                    [keyHeadline]: { props: { centered: textCentered, typography: C.Typography.H3, margins: { bottom: C.Margin.D20 }, maxWidth: textMaxWidth } },
                    [keyBody]: { props: { centered: textCentered, typography: C.Typography.P2, margins: { bottom: C.Margin.D20 }, maxWidth: textMaxWidth } }
                }}
            />
            <div className={css["power-pulse-video"]}>
                <C.InplaceVideo autoPlay loop muted>
                    <source src={srcAnimation ?? `/video/power-pulse.mp4`} type="video/mp4" />
                </C.InplaceVideo>
            </div>
        </C.Card>
    );
}